import { Benefits } from "~landing/components/franchise/benefits";
import { Faqs } from "~landing/components/franchise/faqs";
import { Hero } from "~landing/components/franchise/hero";
import { HowItWorks } from "~landing/components/franchise/how-it-works";
import { StartBuilding } from "~landing/components/franchise/start-building";
import { Testimonials } from "~landing/components/franchise/testimonials";
import { UseCases } from "~landing/components/franchise/use-cases";
import { Layout } from "~landing/components/layout";

export function Franchise() {
	return (
		<Layout>
			<main>
				<Hero />
				<Benefits />
				<UseCases />
				<Testimonials />
				<HowItWorks />
				<Faqs />
				<StartBuilding />
			</main>
		</Layout>
	);
}
